import { type ReactElement, useEffect } from 'react';

import { DocumentTitle } from 'src/components/DocumentTitle';
import { Separator } from 'src/components/ui/separator';
import { useToolbar } from 'src/hooks/useToolbar';
import { cn } from 'src/lib/utils';

type PageLayoutProps = {
  title: string;
  children?: ReactElement[] | ReactElement;
  actions?: ReactElement | ReactElement[];
};

export function PageLayout({
  title,
  children,
  actions,
}: PageLayoutProps): ReactElement {
  const { toolbarTitle, setToolbarTitle } = useToolbar();

  useEffect(() => {
    if (title !== toolbarTitle) {
      setToolbarTitle(title);
    }
  }, [title, toolbarTitle, setToolbarTitle]);

  return (
    <div>
      <DocumentTitle title={title} />

      {actions && (
        <header>
          <div className='mx-auto flex min-h-14 max-w-7xl flex-col justify-between'>
            <div className='flex flex-1 items-center px-4'>{actions}</div>
            <Separator />
          </div>
        </header>
      )}
      <main className={cn(actions && 'mt-4')}>
        <div className='mx-auto max-w-7xl text-layout-foreground'>
          {children}
        </div>
      </main>
    </div>
  );
}
